export default __webpack_public_path__ + "static/media/ionicons.bbef0241.ttf";